import React, { FC, useRef, useCallback, useEffect } from "react"
import Env from "@util/env"
type LabelProps = { visible?: boolean; map: any; onClick: any }
const Label: FC<LabelProps> = ({ visible, map, onClick }) => {
  const ref = useRef<any>()
  const clear = useCallback(() => {
    if (ref.current) {
      // ref.current.clear()
      ref.current.forEach((m) => {
        m.setMap(null)
      })
      ref.current = null
    }
  }, [ref])
  useEffect(() => {
    if (!visible) {
      clear()
    } else if (map) {
      clear()
      const AMap = window.AMap
      var layer = new AMap.LabelsLayer({
        rejectMapMask: true,
        // 开启标注避让，默认为开启，v1.4.15 新增属性
        collision: true,
        // 开启标注淡入动画，默认为开启，v1.4.15 新增属性
        animation: true,
      })
      map.add(layer)
      let name = "AI智能岛"
      // var marker = new AMap.LabelMarker({
      //   name: name,
      //   position: [121.609608, 31.185499],
      //   zooms: [0, 16],
      //   // zIndex: 2,
      //   opacity: 1,
      //   cursor: "pointer",
      //   icon: {
      //     type: "image",
      //     image: require("../../../assets/island.png"),
      //     clipOrigin: [0, 0],
      //     clipSize: [442, 414],
      //     size: [442 / 2, 414 / 2],
      //     anchor: "bottom-center",
      //     angel: 0,
      //     retina: true,
      //   },
      //   // text: {
      //   //   content: name,
      //   //   direction: "right",
      //   //   offset: [0, -5],
      //   //   style: {
      //   //     fontSize: 20,
      //   //     fontWeight: "normal",
      //   //     fillColor: "#fff",
      //   //     // padding: "2, 5",
      //   //     // backgroundColor: "#b1009b",
      //   //   },
      //   // },
      // })
      let w = 442 * Env.getScale()
      let h = 414 * Env.getScale()
      var marker = new AMap.Marker({
        position: new AMap.LngLat(121.608801296660304, 31.184597642924776),
        icon: new AMap.Icon({
          size: new AMap.Size(w, h),
          image: require("../../../assets/island.png"),
          imageSize: new AMap.Size(w / 2, h / 2),
          // imageOffset: new AMap.Pixel(-100, -100),
        }),
        offset: new AMap.Pixel(-w / 4, -h / 2),
        clickable: true,
        // draggable: true,
        zIndex: 1,
      })
      marker.on("click", (e) => {
        // map.setZoom(20)
        // map.setCenter([121.608801296660304, 31.184597642924776])
        onClick()
      })
      // layer.add(marker)
      // ref.current = layer
      var markers = []
      markers.push(marker)

      map.add(markers, {
        zIndex: 1000,
      })
      ref.current = markers
    }
  }, [map, visible, clear, ref])
  useEffect(() => {
    return () => {
      clear()
    }
  }, [clear])
  return null
}

export default Label
